import * as React from 'react';
import { connect } from 'react-redux';

import {
  ILogo,
  IDocument,
} from '../../infrastructure/interfaces';
import LogoEditorForm from '../DocumentEditor/LogoEditorForm';
import {
  toggleLogo,
} from '../../actions/actions';

export interface ILogosChoosingProps {
  document: IDocument;
  logos: ILogo[];
  toggleLogo(logo: ILogo): void;
}

export interface ILogosChoosingState extends React.ComponentState { }

const mapDispatchToProps = (dispatch: any): any => {
  return {
    toggleLogo: (logo: ILogo): void => {
      dispatch(toggleLogo(logo));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
    logos: state.wizard.logos,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class LogosChoosing extends React.Component<any, any> {
  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            Select up to 2 complementary product logos for the back cover:
          </div>
          <div className="stepMessage2">
            You can change this selection later
          </div>
        </div>
        <LogoEditorForm
          className="stepContent"
          document={this.props.document}
          logos={this.props.logos}
          toggleLogo={this.props.toggleLogo}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Steps/LogosChoosing.tsx